import React from 'react';
import './HeroSection.css';
import videoSource from './wed.mp4';

const HeroSection = () => {
  return (
    <header className="hero-section position-relative">
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="hero-video"
      >
        <source src={videoSource} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="container position-relative z-2">
        <div className="row align-items-center min-vh-100">
          <div className="col-12 text-center text-white">
            <h1 className="display-3 fw-bold">Yaadein Films & Photography</h1>
            <h2 className="lead mb-4">Capturing Love Stories</h2>
            <p className="fs-5">
              Preserving the most precious moments of your special day with elegance and artistry.
            Cinematic wedding films & photography — where your story becomes timeless.
            </p>
            <button className="btn btn-primary btn-lg mt-4">View Portfolio</button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator position-absolute bottom-0 start-50 translate-middle-x mb-4">
        <div className="scroll-arrow"></div>
      </div>
    </header>
  );
};

export default HeroSection;
